import PieChart from "components/shared/Charts/PieChart";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardHeader, Spinner } from "reactstrap";
import { fetchTotalCustomer } from "store/actions/statsActions";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

const TotalCustomer = ({ type, dates, merchant }) => {
  const { startDate, endDate } = dates;
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const payload = {
    type,
    dateRange: { startDate, endDate },
    id:
      user?.type === "restaurant"
        ? user?.restaurantID
        : user?.type === "admin" && merchant?.id
        ? merchant?.id
        : ""
  };

  const {
    data: latestTotalCustomer,
    isFetching,
    isError,
    error
  } = useQuery({
    queryKey: ["totalCustomer", payload],
    queryFn: () => dispatch(fetchTotalCustomer(payload)),
    staleTime: 60 * 60 * 1000,
    cacheTime: 70 * 60 * 1000,
    keepPreviousData: true
  });

  const maleCount = latestTotalCustomer?.male || 0;
  const femaleCount = latestTotalCustomer?.female || 0;
  const isEmptyData = maleCount === 0 && femaleCount === 0;
  const chartSeries = isEmptyData ? [] : [maleCount, femaleCount];

  const chartOptions = {
    chart: { type: "pie" },
    labels: ["Male", "Female"],
    legend: { fontFamily: "Poppins, sans-serif" },
    dataLabels: { enabled: true },
    tooltip: { enabled: true }
  };

  if (isError) {
    toast.error(error?.message || "Failed to load payment method data.");
  }

  return (
    <Card className="header-cards card overflow-hidden">
      <CardHeader className="d-flex justify-content-between flex-column flex-sm-row">
        <h3 className="mb-0">Total Customer</h3>
      </CardHeader>
      {isFetching ? (
        <Spinner size="sm" color="primary" className="mx-auto my-5" />
      ) : (
        <CardBody className="d-flex justify-content-center align-items-center">
          <PieChart
            chartOptions={chartOptions}
            chartSeries={chartSeries}
            type="pie"
          />
        </CardBody>
      )}
    </Card>
  );
};

export default TotalCustomer;
